// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1H-Bj","comment":"styles_comment__1bYjW"};